import AbstractConfigProvider from './AbstractConfigProvider';

export default class AppConfigProvider extends AbstractConfigProvider {
    public prefix: string = 'app';

    public getConfig() {
        return {
            ...this.add('currency', process.env.MIX_CURRENCY),
            ...this.add('env', process.env.MIX_ENV),
            ...this.add('locale', process.env.MIX_LOCALE),
        };
    }
}
